PJQ.collections.reports = {};

PJQ.models.reports= {};

PJQ.views.reports = {};

PJQ.modules.reports = {
	routes: [
		{
			route: 'reports',
			name: 'reports',
			callback: function () {
				PJQ.app.initNavigator({
					activeItem: "reports"
				});
			}
		},
		{
			route: 'reportsadhoc',
			name: 'reportsadhoc',
			callback: function () {
				PJQ.app.initNavigator({
					activeItem: "reportsadhoc"
				});
			}
		}
	]
};
PJQ.app.addRoutes(PJQ.modules.reports.routes);
PJQ.constants.reports = {
    dynamicDates: [
        {
            duration: 365,
            value: "pastYear",
            display: "Past Year"
        },
        {
            duration: 180,
            value: "pastSixMonths",
            display: "Past 6 Months"
        },
        {
            duration: 90,
            value: "pastThreeMonths",
            display: "Past 3 Months"
        },
        {
            duration: 30,
            value: "pastMonth",
            display: "Past 1 Month"
        },
        {
            duration: 14,
            value: "pastTwoWeeks",
            display: "Past 2 Weeks"
        },
        {
            duration: 7,
            value: "pastWeek",
            display: "Past Week"
        },
        {
            duration: 2,
            value: "sinceYesterday",
            display: "Since Yesterday"
        },
        {
            duration: 1,
            value: "yesterday",
            display: "Yesterday"
        },
        {
            duration: 1,
            value: "today",
            display: "Today"
        },
        {
            duration: 2,
            value: "throughTomorrow",
            display: "Through Tomorrow"
        },
        {
            duration: 7,
            value: "nextWeek",
            display: "Next Week"
        },
        {
            duration: 14,
            value: "nextTwoWeeks",
            display: "Next 2 Weeks"
        },
        {
            duration: 30,
            value: "nextMonth",
            display: "Next 1 Month"
        },
        {
            duration: 90,
            value: "nextThreeMonths",
            display: "Next 3 Months"
        },
        {
            duration: 180,
            value: "nextSixMonths",
            display: "Next 6 Months"
        },
        {
            duration: 365,
            value: "nextYear",
            display: "Next 1 Year"
        }
    ],
    supportedCustomFieldTypes: [
        'INT',
        'PERCENT',
        'MONEY',
        'STATE',
        // 'CALC',
        'PHONE',
        'TEXT',
        'TEXTAREA',
        'BOOL',
        'CHOICE',
        // GRID: 'GRID',
        // 'CUSTOMGRID'
        // 'GROUPSELECT',
        // 'REGIONSELECT',
        // 'DOWNLOAD',
        // 'UPLOAD',
        // 'FILE',
        'DATE',
        // 'TIME',
        'DATETIME',
    ],
    reportCategorySort: {
        "Custom Reports": 1,
        "Contacts": 2,
        "Project General": 3,
        "Field Tools": 4,
        "Job Costing": 5
    },
    reportTypes: {
        PROJECT_CONTACTS: {
            name: 'Project Contacts',
            type: 'projectContacts',
            key: 'PROJECT_CONTACTS',
            category: 'Contacts',
            isGlobalLevel: false,
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "userType",
                    display: "User Type"
                },
                {
                    value: "companyName",
                    display: "Company Name"
                },
                {
                    value: "contactName",
                    display: "Contact Name"
                },
                {
                    value: "email",
                    display: "Email"
                },
                {
                    value: "phone",
                    display: "Phone"
                },
                {
                    value: "cell",
                    display: "Cell"
                },
                {
                    value: "trades",
                    display: "Trades"
                }
            ],
            filters: [
                {
                    name: 'User Types',
                    key: 'userTypes',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: async function (options) {
                        return new Promise(async (res, rej) => {
                            PJQ.app.session.fetchUserTypes((userTypes) => {
                                res(_.map(userTypes.models, (userType) => {
                                    return {
                                        id: userType.id,
                                        name: userType.get('name')
                                    };
                                }));
                            });
                        });
                    },
                }
            ]
        },
        PREQUAL: {
            name: 'Prequalifications',
            type: 'prequal',
            key: 'PREQUAL',
            category: 'Contacts',
            isProjectLevel: false,
            filterProjects: false,
            columns: async function () {
                let result = [],
                    formData = await PJQ.app.session.fetchPrequalForm();
                if (formData == null || _.size(formData.tabs) === 0) {
                    return result;
                }

                result.push({
                    value: "percentComplete",
                    display: "Overall Progress",
                    group: "Progress"
                });

                let fnMakeCol = (value, name, group, isControlled = false) => {
                    let fieldName = PJQ.templating.TemplateRenderer.parseMarkup(name, {
                        currentYear: PJQ.helpers.dateHelpers.getCurrentYear()
                    });
                    return {
                        value: value,
                        display: '<div class="of-hidden tof-ellipsis no-wrap max-wd-400p pr-4" title="' + fieldName + '">' + (isControlled ? '> ' : '') + fieldName + '</div>',
                        group: group
                    };
                };
                result.push(..._.map(formData.tabs, (tab) => {
                    return fnMakeCol("tabProgress_" + tab.prequalTabId, tab.tabName + " Progress", "Progress");
                }));

                result.push(..._.map(PJQ.constants.reports.reportTypes.PREQUAL.baseColumns.dates, (col) => {
                    return {
                        value: col.value,
                        display: col.display,
                        group: "Dates"
                    };
                }));

                let fieldCols = [],
                    hasContactFields = false;
                _.each(formData.tabs, (tab) => {
                    fieldCols.push(..._.map(_.filter(tab.fields, (field) => {
                        return _.size(field.fieldType) > 0 && PJQ.constants.reports.supportedCustomFieldTypes.indexOf(field.fieldType.toUpperCase()) !== -1;
                    }), (field) => {
                        hasContactFields = hasContactFields || field.fieldName && field.fieldName.toLowerCase().indexOf('contact.') !== -1;

                        let isControlled = null != _.findWhere(field.constraints, {customFieldId: field.prequalFieldId});
                        return fnMakeCol("cf_" + field.prequalFieldId, field.fieldName, tab.tabName, isControlled);
                    }));
                });

                if (!hasContactFields) {
                    let cGroup = 'Contact Info';
                    result.push({
                            value: "contact.companyName",
                            display: "Company Name",
                            group: cGroup
                        },
                        {
                            value: "contact.address",
                            display: "Address",
                            group: cGroup
                        },
                        {
                            value: "contact.city",
                            display: "City",
                            group: cGroup
                        },
                        {
                            value: "contact.state",
                            display: "State",
                            group: cGroup
                        }, {
                            value: "contact.zip",
                            display: "Zip",
                            group: cGroup
                        }, {
                            value: "contact.country",
                            display: "Country",
                            group: cGroup
                        });
                }

                result.push(...fieldCols);

                return result;
            },
            baseColumns: {
                dates: [
                    {
                        value: "signedOn",
                        display: "Date Signed"
                    },
                    {
                        value: "expiresOn",
                        display: "Expiration"
                    },
                    {
                        value: "modifiedOn",
                        display: "Last Modified"
                    },
                    {
                        value: "lastRequestedOn",
                        display: "Last Requested"
                    },
                ]
            },
            filters: [
                {
                    name: 'Date Signed',
                    inputType: 'daterange',
                    dynamicKey: 'signedOn',
                    key: 'signedOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Expiration',
                    inputType: 'daterange',
                    dynamicKey: 'expiresOn',
                    key: 'expiresOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Last Modified',
                    inputType: 'daterange',
                    dynamicKey: 'modifiedOn',
                    key: 'modifiedOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CONTRACT: {
            name: 'Contracts',
            type: 'contract',
            key: 'CONTRACT',
            category: 'Job Costing',
            viewItemColumn: 'number',
            columns: [
                {value: "project", display: "Project"},
                {value: "status", display: "Status"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "created", display: "Created"},
                {value: "start", display: "Start"},
                {value: "estimatedComplete", display: "Est. Complete"},
                {value: "substantialComplete", display: "Substantial Complete"},
                {value: "actualComplete", display: "Act. Complete"},
                {value: "contractDate", display: "Contract Date"},
                {value: "signedDate", display: "Signed Date"},
                {value: "executionDate", display: "Execution Date"},
                {value: "issuedOn", display: "Issued On"},
                {value: "returnedOn", display: "Returned On"},
                {value: "letterOfIntent", display: "Letter Of Intent"},
                {value: "approvalLetter", display: "Approval Letter"},
                {value: "terminationDate", display: "Termination Date"},
                {value: "inclusions", display: "Inclusions"},
                {value: "exclusions", display: "Exclusions"},
                {value: "executed", display: "Executed"},
                {value: "amount", display: "Amount"},
                {value: "approvedChanges", display: "Approved Changes"},
                {value: "contractTotal", display: "Contract Total"},
                {value: "billedToDate", display: "Billed To Date"},
                {value: "amountRemaining", display: "Amount Remaining"},
            ],
            filters: [
                {
                    name: 'Contract Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.primeContracts.primeContractStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.primeContracts.primeContractStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CONTRACT_CHANGE_ORDER: {
            name: 'Contract Change Orders',
            type: 'contractChangeOrder',
            key: 'CONTRACT_CHANGE_ORDER',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'contract',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "status", display: "Status"},
                {value: "contract", display: "Contract"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "invoicedDate", display: "Invoiced Date"},
                {value: "dueDate", display: "Due Date"},
                {value: "created", display: "Created"},
                {value: "amount", display: "Amount"},
            ],
            filters: [
                {
                    name: 'Change Order Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.primeContracts.changeOrderStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.primeContracts.changeOrderStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CHANGE_REQUEST: {
            name: 'Change Requests',
            type: 'changeRequest',
            key: 'CHANGE_REQUEST',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'contract',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "number", display: "Number"},
                {value: "contract", display: "Contract"},
                {value: "title", display: "Title"},
                {value: "scope", display: "Scope"},
                {value: "client", display: "Client"},
                {value: "status", display: "Status"},
                {value: "description", display: "Description"},
                {value: "cost", display: "Cost"},
                {value: "revenue", display: "Revenue"},
                {value: "markupAmount", display: "Markup"},
                {value: "taxAmount", display: "Tax"},
                {value: "grandTotal", display: "Grand Total"},
                {value: "created", display: "Created"},
            ],
            filters: [
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Change Request Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.changeRequests.changeRequestStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.changeRequests.changeRequestStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Scope',
                    key: 'scope',
                    isIntChoices: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.changeRequests.scope, (id) => {
                        return {
                            id: id,
                            name: PJQ.constants.changeRequests.scopeNames[id]
                        };
                    })
                }
            ]
        },
        COMMITMENT: {
            name: 'Commitments',
            type: 'commitment',
            key: 'COMMITMENT',
            viewItemColumn: 'number',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "created", display: "Created"},
                {value: "type", display: "Type"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "delivery", display: "Delivery"},
                {value: "start", display: "Start"},
                {value: "estimatedComplete", display: "Est. Complete"},
                {value: "actualComplete", display: "Act. Complete"},
                {value: "contractDate", display: "Contract Date"},
                {value: "signedDate", display: "Signed Date"},
                {value: "executionDate", display: "Execution Date"},
                {value: "issuedOn", display: "Issued On"},
                {value: "returnedOn", display: "Returned On"},
                {value: "letterOfIntent", display: "Letter Of Intent"},
                {value: "approvalLetter", display: "Approval Letter"},
                {value: "paymentTerms", display: "Payment Terms"},
                {value: "shippingInfo", display: "Shipping Info"},
                {value: "inclusions", display: "Inclusions"},
                {value: "exclusions", display: "Exclusions"},
                {value: "company", display: "Company"},
                {value: "status", display: "Status"},
                {value: "amount", display: "Amount"},
                {value: "approvedChanges", display: "Approved Changes"},
                {value: "contractTotal", display: "Contract Total"},
                {value: "billedToDate", display: "Billed To Date"},
                {value: "amountRemaining", display: "Amount Remaining"},
            ],
            filters: [
                {
                    name: 'Commitment Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.commitments.commitmentStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.commitments.commitmentStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        COMMITMENT_CHANGE_ORDER: {
            name: 'Commitment Change Orders',
            type: 'commitmentChangeOrder',
            key: 'COMMITMENT_CHANGE_ORDER',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'commitment',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "status", display: "Status"},
                {value: "commitment", display: "Commitment"},
                {value: "company", display: "Company"},
                {value: "number", display: "Number"},
                {value: "description", display: "Description"},
                {value: "contractDate", display: "Contract Date"},
                {value: "invoicedDate", display: "Invoiced Date"},
                {value: "dueDate", display: "DueDate"},
                {value: "created", display: "Created"},
                {value: "amount", display: "Amount"},
            ],
            filters: [
                {
                    name: 'Change Order Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.commitments.changeOrderStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.commitments.changeOrderStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        CUSTOM: {
            name: 'Custom',
            type: 'custom',
            key: 'CUSTOM',
            viewItemColumn: '',
            viewRelatedItemColumn: '',
            isCustom: true,
            category: '',
            columns: [],
            filters: []
        },
        DIRECT_COST: {
            name: 'Direct Costs',
            type: 'directCost',
            key: 'DIRECT_COST',
            viewItemColumn: 'created',
            category: 'Job Costing',
            columns: [
                {value: "project", display: "Project"},
                {value: "created", display: "Created"},
                {value: "type", display: "Type"},
                {value: "status", display: "Status"},
                {value: "description", display: "Description"},
                {value: "company", display: "Company"},
                {value: "contact", display: "Contact"},
                {value: "terms", display: "Terms"},
                {value: "applied", display: "Applied"},
                {value: "received", display: "Received"},
                {value: "paid", display: "Paid"},
                {value: "amount", display: "Amount"},
            ],
            filters: [
                {
                    name: 'Direct Cost Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.directcosts.directCostStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.directcosts.directCostStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        PRODUCTION_QUANTITIES: {
            name: 'Production Quantities',
            type: 'productionQuantities',
            key: 'PRODUCTION_QUANTITIES',
            // viewItemColumn: 'created',
            category: 'Field Tools',
            columns: [
                {value: "project", display: "Project"},
                {value: "subJob", display: "Sub Job"},
                {value: "costCode", display: "Cost Code"},
                {value: "quantity", display: "Quantity"},
                {value: "installedQuantity", display: "Installed Quantity"},
                {value: "unit", display: "Unit"},
                {value: "description", display: "Description"}
            ],
            filters: [
                {
                    name: 'Created On Date',
                    inputType: 'daterange',
                    dynamicKey: 'createdOn',
                    key: 'createdOn',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        PAYABLE_INVOICE: {
            name: 'Payable Invoices',
            type: 'payableInvoice',
            key: 'PAYABLE_INVOICE',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'commitment',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "commitment",
                    display: "Commitment"
                },
                {
                    value: "company",
                    display: "Company"
                },
                {
                    value: "billingDate",
                    display: "Due Date"
                },
                {
                    value: "startDate",
                    display: "Start Date"
                },
                {
                    value: "endDate",
                    display: "End Date"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "amount",
                    display: "Amount"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
            ],
            filters: [
                {
                    name: 'Invoice Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.invoicing.payableInvoiceStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.invoicing.payableInvoiceStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'billingDate',
                    key: 'billingDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
        PAYABLE_INVOICE_PAYMENT: {
            name: 'Payable Invoice Payments',
            type: 'payableInvoicePayment',
            key: 'PAYABLE_INVOICE_PAYMENT',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'invoice',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "invoice",
                    display: "Invoice"
                },
                {
                    value: "company",
                    display: "Company"
                },
                {
                    value: "dateReceived",
                    display: "Date Received"
                },
                {
                    value: "paymentMethod",
                    display: "Payment Method"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "amount",
                    display: "Amount"
                }
            ],
            filters: [
                {
                    name: 'Date Received',
                    inputType: 'daterange',
                    dynamicKey: 'dateReceived',
                    key: 'dateReceived',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
        RECEIVABLE_INVOICE: {
            name: 'Receivable Invoices',
            type: 'receivableInvoice',
            key: 'RECEIVABLE_INVOICE',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'contract',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "contract",
                    display: "Contract"
                },
                {
                    value: "billingDate",
                    display: "Due Date"
                },
                {
                    value: "startDate",
                    display: "Start Date"
                },
                {
                    value: "endDate",
                    display: "End Date"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "amount",
                    display: "Amount"
                },
                {
                    value: "notes",
                    display: "Notes"
                }
            ],
            filters: [
                {
                    name: 'Invoice Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.invoicing.receivableInvoiceStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.invoicing.receivableInvoiceStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'billingDate',
                    key: 'billingDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        RECEIVABLE_INVOICE_PAYMENT: {
            name: 'Receivable Invoice Payments',
            type: 'receivableInvoicePayment',
            key: 'RECEIVABLE_INVOICE_PAYMENT',
            viewItemColumn: 'number',
            viewRelatedItemColumn: 'invoice',
            category: 'Job Costing',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "invoice",
                    display: "Invoice"
                },
                {
                    value: "client",
                    display: "Client"
                },
                {
                    value: "dateReceived",
                    display: "Date Received"
                },
                {
                    value: "paymentMethod",
                    display: "Payment Method"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "amount",
                    display: "Amount"
                }
            ],
            filters: [
                {
                    name: 'Date Received',
                    inputType: 'daterange',
                    dynamicKey: 'dateReceived',
                    key: 'dateReceived',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
        ACTION_ITEM: {
            name: 'Action Items',
            type: 'actionItem',
            key: 'ACTION_ITEM',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "itemNumber",
                    display: "Number"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "priority",
                    display: "Priority"
                },
                {
                    value: "category",
                    display: "Category"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "groupList",
                    display: "Trades"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "assignedTo",
                    display: "Assigned To"
                },
                {
                    value: "ballInCourt",
                    display: "Ball In Court"
                }
            ],
            customFields: function () {
                return PJQ.app.session.fetchActionItemCustomFields();
            },
            filters: [
                {
                    name: 'Item Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.actionItems.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.actionItems.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        PUNCH_LIST: {
            name: 'Punch List',
            type: 'punchList',
            key: 'PUNCH_LIST',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "itemNumber",
                    display: "Number"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "assignedTo",
                    display: "Assigned To"
                },
                {
                    value: "priority",
                    display: "Priority"
                },
                {
                    value: "category",
                    display: "Category"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "groupList",
                    display: "Trades"
                },
                {
                    value: "status",
                    display: "Status"
                },
            ],
            customFields: function () {
                return PJQ.app.session.fetchPunchListCustomFields();
            },
            filters: [
                {
                    name: 'Item Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.punchlists.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.punchlists.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        RFI: {
            name: 'RFI',
            type: 'rfi',
            key: 'RFI',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "trades",
                    display: "Trades"
                },
                {
                    value: "status",
                    display: "Status"
                },
            ],
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.rfi.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.rfi.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        SUBMITTAL: {
            name: 'Submittals',
            type: 'submittal',
            key: 'SUBMITTAL',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "submittalNumber",
                    display: "Number"
                },
                {
                    value: "title",
                    display: "Title"
                },
                {
                    value: "itemTypes",
                    display: "Item Types"
                },
                {
                    value: "dueDate",
                    display: "Due Date"
                },
                {
                    value: "groupList",
                    display: "Trades"
                },
                {
                    value: "notes",
                    display: "Description"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "ballInCourt",
                    display: "Ball In Court"
                },
                {
                    value: "submitter",
                    display: "Submitter"
                },
                {
                    value: "approverList",
                    display: "Approver List"
                },
                {
                    value: "distributionList",
                    display: "Distribution List"
                }
            ],
            customFields: function () {
                return PJQ.app.session.fetchSubmittalCustomFields();
            },
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: async function (options) {
                        return new Promise(async (res, rej) => {
                            let statuses;
                            if (options && options.project != null) {
                                statuses = await options.project.fetchSubmittalStatuses();
                            } else {
                                statuses = await PJQ.app.session.fetchSubmittalStatuses();
                            }
                            if (statuses == null) {
                                rej('Failed to fetch statuses');
                            }

                            res(_.map(statuses.models, (status) => {
                                return {
                                    id: status.id,
                                    name: status.get('name')
                                };
                            }));
                        });
                    },
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        TIMECARDS: {
            name: 'Time Cards - Employees',
            type: 'timecards',
            key: 'TIMECARDS',
            category: 'Field Tools',
            columns: [
                {
                    value: "employeeId",
                    display: "Employee Id"
                },
                {
                    value: "companyName",
                    display: "Company"
                },
                {
                    value: "contactName",
                    display: "Contact"
                },
                {
                    value: "date",
                    display: "Date"
                },
                {
                    value: "costCode",
                    display: "Cost Code"
                },
                {
                    value: "hours",
                    display: "Hours"
                },
                {
                    value: "type",
                    display: "Type"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "approvedOn",
                    display: "Approved On"
                },
                {
                    group: "Project",
                    type: "projectBaseFields",
                },
                {
                    group: "Project",
                    type: "projectCustomFields",
                },
                // {
                //     group: "Contact Details",
                //     type: "contactBaseFields",
                //     prefix: "contact.",
                // },
                {
                    group: "Contact Details",
                    type: "contactCustomFields",
                    prefix: "contact.",
                },
                {
                    group: "User Details",
                    type: "userCustomFields",
                    prefix: "user.",
                }
            ],
            filters: [
                {
                    name: 'Date',
                    inputType: 'daterange',
                    dynamicKey: 'date',
                    key: 'date',
                    required: true,
                    allowAll: false,
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        TIMECARDS_EQUIPMENT: {
            name: 'Time Cards - Equipment',
            type: 'timecardsEquipment',
            key: 'TIMECARDS_EQUIPMENT',
            category: 'Field Tools',
            columns: [
                {
                    value: "equipmentName",
                    display: "Equipment"
                },
                {
                    value: "equipmentType",
                    display: "Equipment Type"
                },
                {
                    value: "date",
                    display: "Date"
                },
                {
                    value: "costCode",
                    display: "Cost Code"
                },
                {
                    value: "hours",
                    display: "Hours"
                },
                {
                    value: "type",
                    display: "Type"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "approvedOn",
                    display: "Approved On"
                },
                {
                    group: "Project",
                    type: "projectBaseFields",
                },
                {
                    group: "Project",
                    type: "projectCustomFields",
                }
            ],
            filters: [
                {
                    name: 'Date',
                    inputType: 'daterange',
                    dynamicKey: 'date',
                    key: 'date',
                    required: true,
                    allowAll: false,
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        MEETING: {
            name: 'Meetings',
            type: 'meeting',
            key: 'MEETING',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "name",
                    display: "Name"
                },
                {
                    value: "number",
                    display: "Number"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "date",
                    display: "Date"
                },
                {
                    value: "startTime",
                    display: "Start Time"
                },
                {
                    value: "endTime",
                    display: "End Time"
                },
                {
                    value: "description",
                    display: "Description"
                },
                {
                    value: 'location',
                    display: "Location"
                },
                {
                    value: "isPublic",
                    display: "Public"
                },
            ],
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.meetings.meetingStatus, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.meetings.meetingStatusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Meeting Date',
                    inputType: 'daterange',
                    dynamicKey: 'meetingDate',
                    key: 'meetingDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT: {
            name: 'Daily Reports',
            type: 'dailyReport',
            key: 'DAILY_REPORT',
            sortName: 'Daily Report',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "workLogs",
                    display: "Work Logs"
                },
                {
                    value: "notes",
                    display: "Notes"
                },
                {
                    value: "surveyItems",
                    display: "Survey Items"
                },
                {
                    value: "expenses",
                    display: "Expenses"
                },
                {
                    value: 'deliveries',
                    display: "Deliveries"
                },
                {
                    value: "communicationLogs",
                    display: "Communication Logs"
                },
                {
                    value: "inspectionLogs",
                    display: "Inspection Logs"
                },
                {
                    value: "wasDelayed",
                    display: "Delayed"
                },
                {
                    value: "delayNotes",
                    display: "Delay Notes"
                }
            ],
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Delayed',
                    key: 'delayed',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: [
                        {
                            id: 1,
                            name: 'Yes'
                        },
                        {
                            id: 0,
                            name: 'No'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT_DELIVERY: {
            name: 'Daily Report Deliveries',
            type: 'dailyReportDelivery',
            key: 'DAILY_REPORT_DELIVERY',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "time",
                    display: "Time Delivered"
                },
                {
                    value: "deliveryFrom",
                    display: "Delivery From"
                },
                {
                    value: "contents",
                    display: "Contents"
                },
                {
                    value: "trackingNumber",
                    display: "Tracking Number"
                },
                {
                    value: "purchaseOrderNumber",
                    display: "Purchase Order Number"
                },
                {
                    value: 'notes',
                    display: "Notes"
                }
            ],
            filters: [
                {
                    name: 'Daily Report Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Daily Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT_WORK_LOG: {
            name: 'Daily Report Work Logs',
            type: 'dailyReportWorkLog',
            key: 'DAILY_REPORT_WORK_LOG',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "name",
                    display: "Name"
                },
                {
                    value: "quantity",
                    display: "Quantity"
                },
                {
                    value: "hours",
                    display: "Hours"
                },
                {
                    value: "overtimeHours",
                    display: "Overtime Hours"
                },
                {
                    value: 'trades',
                    display: "Trades"
                },
                {
                    value: "description",
                    display: "Description"
                },
            ],
            filters: [
                {
                    name: 'Daily Report Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Daily Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        DAILY_REPORT_NOTE: {
            name: 'Daily Report Notes',
            type: 'dailyReportNote',
            key: 'DAILY_REPORT_NOTE',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "reportDate",
                    display: "Report Date"
                },
                {
                    value: "category",
                    display: "Category"
                },
                {
                    value: "noteText",
                    display: "Note"
                },
                {
                    value: "created",
                    display: "Created On"
                }
            ],
            filters: [
                {
                    name: 'Daily Report Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.dailyReports.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.dailyReports.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Daily Report Date',
                    inputType: 'daterange',
                    dynamicKey: 'reportDate',
                    key: 'reportDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                }
            ]
        },
        INSPECTION: {
            name: 'Inspections',
            type: 'inspections',
            key: 'INSPECTION',
            category: 'Field Tools',
            columns: [
                {
                    value: "project",
                    display: "Project"
                },
                {
                    value: "name",
                    display: "Name"
                },
                {
                    value: "location",
                    display: "Location"
                },
                {
                    value: "inspectionDate",
                    display: "Inspection Date"
                },
                {
                    value: "dueDate",
                    display: "Due"
                },
                {
                    value: "description",
                    display: "Description"
                },
                {
                    value: "group",
                    display: "Trade"
                },
                {
                    value: "status",
                    display: "Status"
                },
                {
                    value: "assignedTo",
                    display: "Assigned To"
                },
                {
                    value: "pointOfContact",
                    display: "Point of Contact"
                }
            ],
            // customFields: function () {
            //     return PJQ.app.session.fetchActionItemCustomFields();
            // },
            filters: [
                {
                    name: 'Status',
                    key: 'statuses',
                    isIntChoices: true,
                    isMultiple: true,
                    inputType: 'select',
                    choices: _.map(PJQ.constants.inspections.statuses, (statusId) => {
                        return {
                            id: statusId,
                            name: PJQ.constants.inspections.statusNames[statusId]
                        };
                    })
                },
                {
                    name: 'Inspection Date',
                    inputType: 'daterange',
                    dynamicKey: 'inspectionDate',
                    key: 'inspectionDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
                {
                    name: 'Due Date',
                    inputType: 'daterange',
                    dynamicKey: 'dueDate',
                    key: 'dueDate',
                    dates: [
                        {
                            name: 'From',
                            key: 'fromDate'
                        },
                        {
                            name: 'To',
                            key: 'toDate'
                        }
                    ]
                },
            ]
        },
    },
    filterTypes: {
        DATE: 'date',
        DATE_RANGE: 'daterange',
        SELECT: 'select',
    }
};

PJQ.constants.date = {
    WEEKDAYNAMES: [
        {
            short: "Sun",
            shortest: "Su",
            long: "Sunday",
            bit: 1
        },
        {
            short: "Mon",
            shortest: "M",
            long: "Monday",
            bit: 2
        },
        {
            short: "Tue",
            shortest: "T",
            long: "Tuesday",
            bit: 4
        },
        {
            short: "Wed",
            shortest: "W",
            long: "Wednesday",
            bit: 8
        },
        {
            short: "Thu",
            shortest: "Th",
            long: "Thursday",
            bit: 16
        },
        {
            short: "Fri",
            shortest: "F",
            long: "Friday",
            bit: 32
        },
        {
            short: "Sat",
            shortest: "S",
            long: "Saturday",
            bit: 64
        }
    ]
};
PJQ.models.reports.NewReport = PJQ.models.BaseModel.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.options.project && this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        return model;
    },
    getReportOptions: function () {
        let opts = this.get('options');
        return opts ? opts : {};
    },
    getFilters: function () {
        let reportOptions = this.getReportOptions(),
            filters = reportOptions.filters;
        return filters ? filters : {};
    },
    setFilters: function (filters) {
        let options = this.get('options') || {};
        options.filters = filters;
        this.set('options', options);
        this.trigger('change');
    },
    resetFilters: function () {
        let options = this.get('options') || {};
        options.filters = {};
        this.set('options', options);
    },
    setTimezone: function (timezone) {
        let options = this.get('options') || {};
        options.timezone = timezone;
        this.set('options', options);
    },
    resetColumns: function () {
        let options = this.get('options') || {};
        options.columns = {};
        this.set('options', options);
    },
    getColumns: function () {
        let reportOptions = this.getReportOptions();
        return reportOptions.columns ? reportOptions.columns : {};
    },
    setColumns: function (columns) {
        let options = this.get('options') || {};
        options.columns = columns;
        this.set('options', options);
        this.trigger('change');
    },
    generate: function () {
        return new Promise((res, rej) => {
            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'generate'
                    }
                ]),
                data: this.toJSON()
            }).post().done(_.bind(function (response) {
                this.reportData = response;
                res(this.reportData);
            }, this));
        });
    },
    export: function (options = {format: 'pdf'}) {
        return new Promise((res, rej) => {
            let pData = this.toJSON();
            pData.reportResult = this.reportData;

            if (options.rows != null) {
                pData.reportResult.rows = options.rows;
            }

            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'export',
                        value: options && _.size(options.format) > 0 ? options.format : 'pdf'
                    }]),
                data: pData
            }).post().success(_.bind(function (response) {
                PJQ.files.downloadFile(response.url, {
                    isEndpoint: false
                });
                res(response);
            }, this));
        });
    }
});

PJQ.models.reports.CustomReport = PJQ.models.reports.NewReport.extend({
    defaults: {
        isAPIv2: true
    },
    idAttribute: 'id',
    endpoint: function () {
        if (this.options.project && this.isNew()) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom'
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom',
                    value: this.id
                }
            ]);
        }
    },
    parse: function (model) {
        return model;
    },
    getFilters: function () {
        return {};
    },
    getColumns: function () {
        return {};
    },
    export: function (projectId) {
        return new Promise((res, rej) => {
            let params = [];

            if (projectId) {
                params.push({
                    parameter: 'projectId',
                    value: projectId
                });
            }
            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'custom',
                        value: this.id
                    },
                    {
                        endpoint: 'export'
                    }], params),
                data: this.toJSON()
            }).post().success(_.bind(function (response) {
                PJQ.files.downloadFile(response.url, {
                    isEndpoint: false
                });
                res(response);
            }, this)).fail(_.bind(function () {
                res();
            }, this))
        });
    },
    generatePreview: function (projectId) {
        let params = [];

        if (projectId) {
            params.push({
                parameter: 'projectId',
                value: projectId
            });
        }
        return new Promise((res, rej) => {
            new PJQ.ajax.Request({
                isAPIv2: true,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'reports'
                    },
                    {
                        endpoint: 'custom',
                        value: this.id
                    },
                    {
                        endpoint: 'preview'
                    }], params),
                data: this.toJSON()
            }).post().success(_.bind(function (response) {
                res(response);
            }, this)).fail(_.bind(function () {
                res();
            }, this))
        });
    }
});

PJQ.models.reports.ReportOptions = PJQ.models.BaseModel.extend({});

PJQ.collections.reports.NewReportList = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.reports.NewReport,
    endpoint: function () {
        let params = [];
        if (this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                }
            ], params);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                }
            ], params);
        }
    }
});

PJQ.collections.reports.CustomReports = PJQ.collections.BaseCollection.extend({
    defaults: {
        isAPIv2: true
    },
    model: PJQ.models.reports.CustomReport,
    endpoint: function () {
        let params = [];
        if (this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom'
                }
            ], params);
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'custom'
                }
            ], params);
        }
    }
});
PJQ.views.reporting.NewReportView = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'new-report-view'),
        subTemplates: {
            reportError: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-error')
        }
    },
    events: {
        'click .create-report': 'createNewReport',
        'click .btn-save-report': 'saveReport',
        'click .btn-generate-report': 'generateReport',
        'click .btn-reset-filters': 'resetFilters',
        'click .input-my-projects': 'toggleMyProjects',
        'click .input-toggle-specific-dates': 'toggleSpecificDates',
        'click .report-export-excel': 'exportExcel',
        'click .report-export-pdf': 'exportPDF',
        'click .btn-custom-export': 'exportCustom',
        'click .btn-delete-report': 'deleteReport',
        'click .btn-clear-report': 'clearReport',
        'click .btn-reset-columns': 'resetColumns'
    },
    beforeFirstRender: async function () {
        if (!this.collection) {
            this.collection = new PJQ.collections.reports.NewReportList(null, {
                project: this.options.project
            });
        }

        if (!this.customReports) {
            this.customReports = new PJQ.collections.reports.CustomReports(null, {
                project: this.options.project
            });
        }

        await this.collection.fetch();
        await this.customReports.fetch();

        if (!this.options.project) {
            this.projects = new PJQ.collections.projects.Projects(null, {
                isSimple: false,
                status: 'ready'
            });

            await PJQ.app.session.fetchProjectStatuses();
            await this.projects.fetch();
        }
        this.render();
    },
    renderData: function () {
        return {
            report: this.report,
            reportType: this.reportType,
            reportList: this.collection,
            projects: this.projects
        };
    },
    getReportChoices: function () {
        let rTypes = _.filter(PJQ.constants.reports.reportTypes, (reportType) => {
                return !reportType.isCustom
                    && ((this.options.project != null && reportType.isProjectLevel !== false)
                        || (this.options.project == null && reportType.isGlobalLevel !== false));
            }),
            result = _.map(_.groupBy(rTypes, 'category', this), (reportTypes, category) => {
                return {
                    name: category,
                    choices: _.map(
                        _.sortBy(reportTypes, (reportType) => {
                            if (reportType.sortName)
                                return reportType.sortName;

                            return reportType.name;
                        }),
                        (reportType) => {
                            return {
                                id: reportType.key,
                                name: reportType.name
                            };
                        }
                    )
                };
            });

        if (_.size(this.customReports.models) > 0) {
            result.push({
                name: 'Custom Reports',
                choices: _.map(this.customReports.models, function (report) {
                    return {
                        id: 'custom_' + report.id.toString(),
                        name: report.get('name')
                    };
                })
            });
        }

        return _.sortBy(result, (rt) => {
            let s = PJQ.constants.reports.reportCategorySort[rt.name];
            return s ? s : 100;
        });
    },
    makeCustomReportType: async function (report, callback) {
        return new Promise(async (res, rej) => {
            let reportOpts = report.get('options'),
                key = report.get('key'),
                result = {
                    name: report.get('name') ?? "",
                    type: key,
                    key: key,
                    viewItemColumn: '',
                    viewRelatedItemColumn: '',
                    category: '',
                    columns: reportOpts?.columns ?? [],
                    filters: [],
                    isCustom: true
                };

            let filters = reportOpts.filterOptions;
            if (_.size(filters) > 0) {
                let hasProjectCustomFieldFilter = null != _.find(filters, (filter) => {
                        return filter.projectCustomFieldId > 0;
                    }),
                    projectCustomFields = null;

                if (hasProjectCustomFieldFilter) {
                    projectCustomFields = await PJQ.app.session.fetchProjectCustomFields();
                }

                result.filters = [];
                _.each(filters, (filter) => {
                    if (filter.projectCustomFieldId > 0) {
                        let field = projectCustomFields.get(filter.projectCustomFieldId);
                        if (field != null) {
                            result.filters.push({
                                name: field.get('fieldName'),
                                key: 'p_fieldValue' + field.id.toString(),
                                isIntChoices: true,
                                isMultiple: true,
                                inputType: 'select',
                                choices: _.map(field.choices.models, (choice) => {
                                    return {
                                        id: choice.id,
                                        name: choice.get('choiceName')
                                    };
                                })
                            });

                            result.inputType = 'select';
                            result.isMultiple = false;
                            result.isIntChoices = true;
                            result.choices = _.map(field.choices.models, (choice) => {
                                return {
                                    id: choice.id,
                                    name: choice.get('name')
                                };
                            })
                        }
                    } else {
                        result.filters.push(filter);
                    }
                });
            }

            if (typeof callback === 'function') {
                callback(result);
            }

            res(result);
        });
    },
    afterRender: async function () {
        this.reportTypePicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-report-type'),
            defaultValue: this.reportType ? this.reportType.key : null,
            noneSelectedText: 'Select Report Type',
            choices: this.getReportChoices(),
            isMultiple: false,
            isIntChoices: false,
            onChange: (value) => {
                if (value.startsWith('custom_')) {
                    let reportId = parseInt(value.replace('custom_', '')),
                        report = this.customReports.get(reportId);
                    if (report != null) {
                        this.makeCustomReportType(report, (reportType) => {
                            this.report = report;
                            this.reportType = reportType;
                            this.reportType.key = value;
                            this.render();
                        });
                    }
                    return;
                }

                this.reportType = PJQ.constants.reports.reportTypes[value];
                this.report = new PJQ.models.reports.NewReport({
                    type: this.reportType.type,
                    projectId: this.options.project ? this.options.project.id : null
                }, {
                    project: this.options.project
                });
                this.report.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);

                this.render();
            }
        });

        let selectedReportId = this.report ? this.report.get('type') != null ? this.report.id : -this.report.id : null;
        this.savedReportPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-saved-report'),
            defaultValue: selectedReportId,
            noneSelectedText: _.size(this.collection.models) > 0 || _.size(this.customReports.models) > 0 ? 'Select Saved Report' : 'No saved reports exist',
            isDisabled: _.size(this.collection.models) === 0 || _.size(this.customReports.models) > 0,
            isMultiple: false,
            isIntChoices: true,
            onChange: _.bind(function (value) {
                if (value > 0) {
                    let report = this.collection.get(value);
                    // If the report type changed, re-render to get the correct filter elements
                    if (this.reportType !== report.get('type')) {
                        this.reportType = _.find(PJQ.constants.reports.reportTypes, function (reportType) {
                            return reportType.type === report.get('type');
                        });

                        this.report = report;
                        this.report.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
                        if (this.options.project != null) {
                            this.report.set('projectId', this.options.project.id);
                        }

                        this.render();
                    } else {
                        this.renderReport(report);
                    }
                } else {
                    this.render();
                }
            }, this)
        });

        this.populateReportSelect();
        if (this.report) {
            this.renderReport(this.report);
            this.renderDataTable();

            // If this.report is an existing report on render, then generate it immediately
            if (!this.report.isNew() && !this.report.reportData) {
                this.generateReport();
            }
        }
    },
    generateReport: function () {
        if (this.reportType.isCustom && this.report.get('options').exportOnly) {
            return
        } else if (!this.reportType.isCustom && !this.validate()) {
            return;
        }

        this.report.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);

        if (this.reportType.isCustom) {
            let projectId = this.options.project ? this.options.project.id : null;
            this.report.generatePreview(projectId).then((response) => {
                if (response && response.content) {
                    let unescapedHtml = this.unescapeHtml(response.content);

                    let iframe = document.createElement('iframe');
                    iframe.style.width = '100%';
                    iframe.style.height = '100%';
                    iframe.style.border = 'none';

                    iframe.onload = function () {
                        iframe.contentWindow.document.open();
                        iframe.contentWindow.document.write(unescapedHtml);
                        iframe.contentWindow.document.close();
                    };

                    let container = this.$('.custom-report-preview')[0];
                    container.innerHTML = '';
                    container.appendChild(iframe);
                }
            });
        } else {
            let loader = new PJQ.Loader(this.$('.report-table'));
            this.report.setFilters(this.reportFilters);

            this.report.generate().then((response) => {
                loader.remove();
                this.renderDataTable();
            });
        }
    },
    unescapeHtml: function (html) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = html;
        return textArea.value;
    },
    exportExcel: function () {
        if (!this.validate()) {
            return;
        }

        let loader = new PJQ.Loader(this.$('.btn-export'));
        this.report.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        this.report.setFilters(this.reportFilters);
        this.report.export({
            format: 'excel',
            rows: this.dataTable ? this.dataTable.dataTable.rows({order: 'applied'}).data().toArray() : null
        }).then((response) => {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
            loader.remove();
        });
    },
    exportPDF: function () {
        if (!this.validate()) {
            return;
        }
        // todo: add loader to export button
        this.report.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        this.report.setFilters(this.reportFilters);
        this.report.export({
            format: 'pdf',
            rows: this.dataTable ? this.dataTable.dataTable.rows({order: 'applied'}).data().toArray() : null
        }).then((response) => {
            // todo: remove loader from export button
        });
    },
    exportCustom: function () {
        let loader = new PJQ.Loader(this.$('.btn-custom-export'), {
            type: 'button',
            loadingText: 'Exporting'
        });

        let projectId = this.options.project ? this.options.project.id : null;
        this.report.setTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone);
        this.report.export(projectId).then((response) => {
            loader.remove();
        });
    },
    toggleSpecificDates: function (e) {
        let $switch = $(e.currentTarget),
            $container = $switch.closest('.col-4'),
            $dynamicDateInput = $container.find('.input-dynamic-date'),
            $specificDateInput = $container.find('.input-specific-date'),
            filters = this.report.getFilters();

        // When the user switches between dynamic/specific, we want to clear the filter of the other.
        if ($switch.prop('checked')) {
            // hide and clear the value of the select input
            $dynamicDateInput.hide().find('select').selectpicker('val', '');
            $specificDateInput.show();

            let key = $dynamicDateInput.find('select').data('key');
            // remove the key from the filters object
            delete filters[key];
            this.report.setFilters(filters);
        } else {
            // hide and clear the value of both of the date inputs
            $specificDateInput.hide().find('.filter-date').val('');
            $dynamicDateInput.show();

            let key = $specificDateInput.data('key');
            // remove the key from the filters object
            delete filters[key];
            this.report.setFilters(filters);
        }
    },
    deleteReport: function () {
        if (this.report.id == null)
            return;

        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this report?",
            onDelete: _.bind(function () {
                this.collection.remove(this.report);
                this.report.destroy({
                    success: _.bind(function () {
                        this.clearReport();
                    }, this)
                });
            }, this)
        });
    },
    clearReport: function () {
        this.report = null;
        this.reportType = null;
        this.render();
    },
    toggleMyProjects: function (e) {
        let $input = this.$('.input-my-projects'),
            filters = this.report.getFilters(),
            isChecked = $input[0].checked;

        filters.isMyProjects = isChecked;

        this.report.setFilters(filters);
        this.render();
    },
    renderReport: function (report) {
        // Stop listening to existing report
        if (this.report != null) {
            this.stopListening(this.report);
        }

        if (report != null) {
            this.report = report;
            this.reportFilters = _.clone(this.report.getFilters());
            this.$('.btn-delete-report').attr('hidden', this.report.id == null);
            this.listenTo(this.report, 'change reset', _.bind(function () {
                this.$('.btn-save-report').prop('disabled', !this.report.hasChanged());
            }, this));
        }
        this.$('.btn-save-report').prop('disabled', !this.report.hasChanged())
        this.renderFilterInputs();
    },
    getColumnChoices: async function () {
        if (!this.reportType)
            return [];

        let rCols = [];
        if (typeof this.reportType.columns === 'function') {
            rCols = await this.reportType.columns();
        } else {
            rCols = _.clone(this.reportType.columns);
        }

        let columns = [];
        for (let i = 0; i < rCols.length; i++) {
            let column = rCols[i];
            if (_.size(column.type) > 0) {
                switch (column.type.toLowerCase()) {
                    case 'contactbasefields':
                        columns.push(...[
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'id',
                                display: 'Contact Id'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'companyName',
                                display: 'Company Name'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'contactName',
                                display: 'Contact Name'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'address1',
                                display: 'Address 1'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'address2',
                                display: 'Address 2'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'city',
                                display: 'City'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'state',
                                display: 'State'
                            },
                            {
                                group: column.group,
                                value: (column.prefix ?? "") + 'zip',
                                display: 'Zip'
                            }
                        ]);
                        break;
                    case 'contactcustomfields':
                        let contactCustomFields = await PJQ.app.session.fetchContactCustomFields();
                        columns.push(..._.map(contactCustomFields.models, (field) => {
                            return {
                                group: column.group,
                                value: (column.prefix ?? "") + 'fieldValue' + field.id.toString(),
                                display: field.get('fieldName')
                            };
                        }));
                        break;
                    case 'usercustomfields':
                        let userCustomFields = await PJQ.app.session.fetchUserCustomFields();
                        columns.push(..._.map(userCustomFields.models, (field) => {
                            return {
                                group: column.group,
                                value: (column.prefix ?? "") + 'fieldValue' + field.id.toString(),
                                display: field.get('fieldName')
                            };
                        }));
                        break;
                    case 'projectbasefields':
                        columns.push(...[
                            {
                                group: column.group,
                                value: 'p_erp.externalNumber',
                                display: 'ERP Project #'
                            },
                            {
                                group: column.group,
                                value: 'p_id',
                                display: 'Project Id'
                            },
                            {
                                group: column.group,
                                value: 'p_projectName',
                                display: 'Project Name'
                            },
                            {
                                group: column.group,
                                value: 'p_address1',
                                display: 'Address 1'
                            },
                            {
                                group: column.group,
                                value: 'p_address2',
                                display: 'Address 2'
                            },
                            {
                                group: column.group,
                                value: 'p_city',
                                display: 'City'
                            },
                            {
                                group: column.group,
                                value: 'p_state',
                                display: 'State'
                            },
                            {
                                group: column.group,
                                value: 'p_zip',
                                display: 'Zip'
                            }
                        ]);
                        break;
                    case 'projectcustomfields':
                        let projectCustomFields = await PJQ.app.session.fetchProjectCustomFields();
                        columns.push(..._.map(projectCustomFields.models, (field) => {
                            return {
                                group: column.group,
                                value: (column.prefix ?? "p_") + 'fieldValue' + field.id.toString(),
                                display: field.get('fieldName')
                            };
                        }));
                        break;
                }
                continue;
            }

            columns.push(column);
        }

        if (typeof this.reportType.customFields === 'function') {
            let customFields = await this.reportType.customFields();
            if (customFields != null) {
                _.each(customFields.models, (field) => {
                    columns.push({
                        id: "fieldValue" + field.get('fieldNumber'),
                        name: field.get('fieldName')
                    });
                });
            }
        }

        let result = [],
            columnGroups = _.groupBy(columns, (col) => {
                return col.group ? col.group : '';
            }, this),
            fnMakeChoice = (column) => {
                return {
                    id: column.value ?? column.id,
                    name: column.display ?? column.name
                };
            }

        if (_.size(columnGroups) === 0) {
            result.push(..._.map(columns, fnMakeChoice));
        } else {
            _.map(columnGroups, (columns, group) => {
                result.push({
                    name: group,
                    choices: _.map(columns, fnMakeChoice)
                });
            });
        }

        return result;
    },
    renderFilterInputs: async function () {
        if (!this.reportType.isCustom) {
            let columnChoices = await this.getColumnChoices();
            this.columnsPicker = new PJQ.inputs.Selectpicker({
                el: this.$('.select-columns'),
                noneSelectedText: 'No Columns Selected',
                defaultValue: this.report.getColumns(),
                isMultiple: true,
                choices: columnChoices,
                isLiveSearch: true,
                onChange: _.bind(function (value) {
                    this.report.setColumns(value);
                }, this)
            });

            if (this.projects && this.reportType.filterProjects !== false) {
                this.$('.input-my-projects')[0].checked = this.reportFilters.isMyProjects;
                this.projectsSelector = new PJQ.views.projects.ProjectSelectorInput({
                    el: this.$('.report-projects'),
                    isSingleChoice: false,
                    canEdit: !this.reportFilters.isMyProjects,
                    emptyNotice: this.reportFilters.isMyProjects ? '"My Projects" is checked. This report will only use projects you are a contact on.' : 'No Project Filters',
                    selectedProjectIds: this.reportFilters.isMyProjects ? [] : this.reportFilters.projects,
                    projects: this.projects,
                    onChange: _.bind(function (selectedProjects) {
                        let idArr = _.map(selectedProjects, function (project) {
                            return project.get('projectId') ? project.get('projectId') : project.id;
                        });
                        this.reportFilters.projects = idArr;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });

                this.projectStatusPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-project-status-filter'),
                    defaultValue: this.reportFilters.projectStatuses,
                    noneSelectedText: 'Select Project Statuses',
                    isMultiple: true,
                    isIntChoices: true,
                    onChange: _.bind(function (value) {
                        this.reportFilters.projectStatuses = value;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });
            }
        }

        this.filterInputs = {};
        _.each(this.reportType.filters, async (filter) => {
            if (filter.inputType === PJQ.constants.reports.filterTypes.SELECT) {
                let choices;
                if (typeof filter.choices === 'function') {
                    choices = await filter.choices({project: this.options.project});
                } else {
                    choices = filter.choices;
                }

                this.filterInputs[filter.key] = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-filter[data-key="' + (filter.key) + '"]'),
                    defaultValue: this.reportFilters[filter.key],
                    choices: choices,
                    noneSelectedText: 'Select ' + filter.name,
                    isMultiple: filter.isMultiple,
                    isIntChoices: filter.isIntChoices,
                    onChange: _.bind(function (value) {
                        this.reportFilters[filter.key] = value;
                        this.report.setFilters(this.reportFilters);
                    }, this)
                });
            } else if (filter.inputType === PJQ.constants.reports.filterTypes.DATE_RANGE) {
                let $range = this.$('.input-specific-date[data-key="' + (filter.key) + '"]'),
                    dateRange = [null, null],
                    defaultDateOne = this.reportFilters[filter.key] ? PJQ.helpers.dateHelpers.parseDateString(dateRange[0], false) : null,
                    defaultDateTwo = this.reportFilters[filter.key] ? PJQ.helpers.dateHelpers.parseDateString(dateRange[1], false) : null,
                    fnSetFilter = () => {
                        let date1 = dateRange[0] ? dateRange[0] : "null",
                            date2 = dateRange[1] ? dateRange[1] : "";
                        this.reportFilters[filter.key] = date1 + '|' + date2;
                        this.report.setFilters(this.reportFilters);
                    },
                    datePickerFrom = new PJQ.inputs.Datepicker({
                        el: $range.find('.date-from'),
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: null,
                            maxDuration: filter.maxDuration ?? null
                        },
                        onChange: _.bind(function (date) {
                            let daysDiff = PJQ.helpers.dateHelpers.getDateDaysDiff(new Date(dateRange[1]), date);
                            if (date != null && _.size(dateRange) === 2 && dateRange[1] != null && daysDiff > filter.maxDuration) {
                                let nDate = PJQ.helpers.dateHelpers.getNewDateAddDays(date, filter.maxDuration);
                                dateRange[1] = PJQ.helpers.dateHelpers.getDateString(nDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                datePickerTo.setValue(nDate);
                            } else if (daysDiff < 0) {
                                dateRange[1] = PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                datePickerTo.setValue(date);
                            }

                            dateRange[0] = date ? PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                            fnSetFilter();
                        }, this)
                    }),
                    datePickerTo = new PJQ.inputs.Datepicker({
                        el: $range.find('.date-to'),
                        datepickerOptions: {
                            format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                            defaultDate: null,
                            maxDuration: filter.maxDuration ?? null
                        },
                        onChange: _.bind(function (date) {
                            let daysDiff = PJQ.helpers.dateHelpers.getDateDaysDiff(date, new Date(dateRange[0]));
                            if (date != null && _.size(dateRange) === 2 && dateRange[0] != null && daysDiff > filter.maxDuration) {
                                let nDate = PJQ.helpers.dateHelpers.getNewDateAddDays(date, -filter.maxDuration);
                                dateRange[0] = PJQ.helpers.dateHelpers.getDateString(nDate, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                datePickerFrom.setValue(nDate);
                            } else if (daysDiff < 0) {
                                dateRange[0] = PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE);
                                datePickerFrom.setValue(date);
                            }

                            dateRange[1] = date ? PJQ.helpers.dateHelpers.getDateString(date, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                            fnSetFilter();
                        }, this)
                    });

                let filterVal = this.reportFilters[filter.dynamicKey],
                    dynVal = null;
                if (typeof filterVal === 'string') {
                    dynVal = filterVal.replace('dyn:', '');
                }
                let dynPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-dynamic-date[data-key="' + (filter.dynamicKey) + '"]'),
                    defaultValue: dynVal,
                    noneSelectedText: 'Select ' + filter.name + ' Range',
                    isMultiple: false,
                    choices: function () {
                        let res = [];
                        if (filter.maxDuration == null && filter.allowAll !== false) {
                            res.push({
                                id: '',
                                name: 'All'
                            });
                        }
                        res.push(..._.map(_.filter(PJQ.constants.reports.dynamicDates, (value) => {
                            return filter.maxDuration == null || value.duration == null || filter.maxDuration >= value.duration;
                        }), function (value) {
                            return {
                                id: value.value,
                                name: value.display
                            };
                        }));
                        return res;
                    },
                    isIntChoices: false,
                    onChange: (value) => {
                        this.reportFilters[filter.dynamicKey] = _.size(value) > 0 ? ("dyn:" + value) : null;
                        this.report.setFilters(this.reportFilters);
                    }
                });

                datePickerFrom.setValueSilently(defaultDateOne);
                datePickerTo.setValueSilently(defaultDateTwo);

                if (filter.defaultValue != null && filter.defaultValue.indexOf("dyn:") === 0) {
                    dynPicker.setValue(filter.defaultValue.replace('dyn:', ''));
                    this.reportFilters[filter.dynamicKey] = filter.defaultValue;
                    this.report.setFilters(this.reportFilters);
                    this.generateReport();
                }

                this.filterInputs[filter.key] = {
                    datePickers: [datePickerFrom, datePickerTo, dynPicker]
                }
            }
        }, this)
    },
    renderDataTable: function () {
        let filteredMoneyColumns;
        // Currently we only want to render a footer for money columns
        if (this.report && this.report.reportData) {
            filteredMoneyColumns = _.filter(this.report.reportData.columns, function (column) {
                return column.type === 'money';
            }, this)
        }

        let order = [],
            opts = this.report.get('options'),
            cOrder = opts ? this.report.get('options').columnOrder : null;
        if (this.report.reportData && this.report.reportData.columns && _.size(cOrder) >= 2 &&
            this.report.get('options').columnOrder[0] < _.size(this.report.reportData.columns)) {
            order = [cOrder];
        }

        this.dataTable = new PJQ.views.reporting.ReportCenterDataTable({
            el: this.$('.report-table'),
            paging: false,
            hasFooter: _.size(filteredMoneyColumns) > 0,
            data: this.report.reportData ? this.report.reportData.rows : null,
            columnData: this.report.reportData ? this.report.reportData.columns : null,
            order: order,
            reportType: this.reportType,
            orderByChanged: _.bind(function (details) {
                let options = this.report.get('options');
                options.columnOrder = [details[0].col, details[0].dir];
                this.report.set('options', options);
            }, this),
            columnOrderChanged: _.bind(function (columns) {
                this.report.setColumns(_.map(columns, function (column) {
                    return column.data;
                }));
            }, this),
            afterDataTableRender: _.bind(function () {
                if (_.size(filteredMoneyColumns) > 0) {
                    this.renderTableFooter();
                }
            }, this),
            viewItem: _.bind(function (id) {
                if (id) {
                    this.viewReportItem(id);
                }
            }, this),
            viewRelatedItem: _.bind(function (id) {
                if (id) {
                    this.viewRelatedReportItem(id);
                }
            }, this)
        });
    },
    renderTableFooter: function () {
        let $footer = this.$('tfoot').first();
        _.each(this.report.reportData.columns, function (column, index) {
            if (column.type != null && column.type.toLowerCase() === 'money') {
                let total = 0;
                _.each(this.report.reportData.rows, function (row) {
                    if (row.data[column.index] != null) {
                        total += parseInt(PJQ.helpers.formatHelpers.numbersOnly(row.data[column.index], false, true));
                    }
                });

                let $footerCol = $footer.find('th').eq(index);
                $footerCol.text(PJQ.helpers.formatHelpers.formatCurrency(total));
            }
        }, this);
    },
    viewReportItem: function (id) {
        switch (this.reportType.type) {
            case PJQ.constants.reports.PAYABLE_INVOICE.type:
                new PJQ.views.invoicing.EditPayableInvoiceModal({
                    model: new PJQ.models.invoicing.PayableInvoice({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.RECEIVABLE_INVOICE.type:
                new PJQ.views.invoicing.EditReceivableInvoiceModal({
                    model: new PJQ.models.invoicing.ReceivableInvoice({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.DIRECT_COST.type:
                new PJQ.views.directcosts.DirectCostEditModal({
                    model: new PJQ.models.directcosts.DirectCost({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.COMMITMENT.type:
                new PJQ.views.commitments.CommitmentEditModal({
                    model: new PJQ.models.commitments.Commitment({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.CONTRACT.type:
                new PJQ.views.primeContracts.PrimeContractEditModal({
                    model: new PJQ.models.primeContracts.PrimeContract({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.CONTRACT_CHANGE_ORDER.type:
                new PJQ.views.primeContracts.ChangeOrderEditModal({
                    model: new PJQ.models.primeContracts.ChangeOrder({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.COMMITMENT_CHANGE_ORDER.type:
                new PJQ.views.commitments.ChangeOrderEditModal({
                    model: new PJQ.models.commitments.ChangeOrder({
                        id: id
                    })
                })
                break;
        }
    },
    viewRelatedReportItem: function (id) {
        switch (this.reportType.type) {
            case PJQ.constants.reports.PAYABLE_INVOICE.type:
                new PJQ.views.commitments.CommitmentEditModal({
                    model: new PJQ.models.commitments.Commitment({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.RECEIVABLE_INVOICE.type:
                new PJQ.views.primeContracts.PrimeContractEditModal({
                    model: new PJQ.models.primeContracts.PrimeContract({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.CONTRACT_CHANGE_ORDER.type:
                new PJQ.views.primeContracts.PrimeContractEditModal({
                    model: new PJQ.models.primeContracts.PrimeContract({
                        id: id
                    })
                })
                break;
            case PJQ.constants.reports.COMMITMENT_CHANGE_ORDER.type:
                new PJQ.views.commitments.CommitmentEditModal({
                    model: new PJQ.models.commitments.Commitment({
                        id: id
                    })
                })
                break;
        }
    },
    validate: function () {
        let isValid = true;
        if (_.size(this.report.getColumns()) === 0) {
            isValid = false;
        }

        if (this.columnsPicker != null) {
            isValid ? this.columnsPicker.hideError() : this.columnsPicker.showError();
        }

        _.each(this.reportType.filters, (filter) => {
            if (!filter.required) {
                return;
            }

            let filterInput = this.filterInputs[filter.key];
            if (filterInput == null) {
                return;
            }

            if (filter.inputType === PJQ.constants.reports.filterTypes.SELECT) {
                if (this.reportFilters[filter.key] == null) {
                    isValid = false;
                    filterInput.showError();
                    return;
                }
                filterInput.hideError();
            } else if (filter.inputType === PJQ.constants.reports.filterTypes.DATE_RANGE) {
                _.each(filterInput.datePickers, (datePicker) => {
                    if (this.reportFilters[filter.key] == null) {
                        isValid = false;
                        datePicker.showError();
                        return;
                    }
                    datePicker.hideError();
                });
            }
        });

        return isValid;
    },
    saveReport: function () {
        if (!this.validate()) {
            return;
        }

        let isNew = this.report.isNew();
        new PJQ.views.reporting.EditReportModal({
            project: this.options.project,
            model: this.report,
            onSave: _.bind(function () {
                this.report.save(null, {
                    success: _.bind(function (model) {
                        if (isNew) {
                            this.collection.add(model);
                        }
                        this.populateReportSelect();

                        PJQ.notifications.notify.successNotify({
                            message: 'Report successfully saved'
                        });
                    }, this)
                })
            }, this)
        });
    },
    populateReportSelect: function () {
        // Group the reports by their type
        let groupedReports = _.groupBy(this.collection.models, function (report) {
            return report.get('type');
        });

        // Convert groupedReports to the format that updateChoices expects
        let choices = _.map(groupedReports, function (reports, type) {
            return {
                name: _.find(PJQ.constants.reports.reportTypes, function (reportType) {
                    return reportType.type === type;
                }).name,
                choices: _.map(reports, function (report) {
                    return {
                        id: report.id,
                        name: report.get('name'),
                        isCustom: false
                    };
                })
            };
        });

        if (this.savedReportPicker) {
            this.savedReportPicker.updateChoices(choices);
            let selectedReportId = this.report ? this.report.get('type') != null ? this.report.id : -this.report.id : null;
            this.savedReportPicker.setValue(selectedReportId);
            if (_.size(this.collection.models) > 0 || _.size(this.customReports.models) > 0) {
                this.savedReportPicker.enable();
            } else {
                this.savedReportPicker.disable();
            }
        }

        if (this.report) {
            this.$('.btn-delete-report').attr('hidden', this.report.id == null);
        }
    },
    resetFilters: function () {
        this.report.resetFilters();
        this.render();
    },
    resetColumns: function () {
        this.report.resetColumns();
        this.render();
    }
});

PJQ.views.reporting.EditReportModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'modal-edit-report'),
        width: '50%',
        maxWidth: 400,
        model: null,
        isShowCloseButton: true,
    },
    events: {
        'click .btn-close': 'close',
        'click .btn-save': 'save'
    },
    beforeRender: function () {

    },
    renderData: function () {
        return {
            model: this.model
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.model, {
            watchElements: ['input']
        });

        this.setInputFocus(this.$('.input-report-name')[0]);
    },
    setInputFocus: function (input) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
    },
    save: function () {
        this.options.onSave(this.model);
        this.removeModal();
    },
    close: function () {
        this.removeModal();
    }
});

PJQ.views.reporting.ReportCenterDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'Select from your saved reports, or create a new one to get started',
            zeroRecords: "No records match your request"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'data-table-header-report-center')
        },
        colReorder: {
            realtime: false
        }
    },
    events: {
        'click .view-item': 'viewItem',
        'click .view-related-item': 'viewRelatedItem'
    },
    afterHeaderRender: function () {

    },
    getColumns: function () {
        let columns = []

        if (this.options.columnData) {
            _.each(this.options.columnData, function (column) {
                columns.push({
                    "data": column.dataValue,
                    "title": column.displayValue,
                    "render": _.bind(function (dt, type, row) {
                        let data = row.data[column.index],
                            displayValue = data && data.text ? data.text : data;
                        if (column.type.toLowerCase() === 'money') {
                            displayValue = PJQ.helpers.formatHelpers.formatCurrency(displayValue);
                        }

                        if (column.type.indexOf('viewItem:') !== -1) {
                            let itemType = column.type.replace('viewItem:', '');
                            return '<a class="view-item" href="javascript:void(0)" data-item-type="' + itemType + '" data-id="' + row.props.id + '">' + displayValue + '</a>';
                        } else if (column.type === 'url') {
                            return '<a class="view-item" target="_blank" href="#' + data.url + '">' + displayValue + '</a>';
                        }
                        return displayValue;
                    }, this)
                });
            }, this)
        } else {
            columns.push({
                "data": '',
                "title": '',
            })
        }

        return columns;
    },
    viewItem: function (e) {
        e.stopImmediatePropagation();
        let id = $(e.currentTarget).data('id');
        if (typeof this.options.viewItem === 'function') {
            this.options.viewItem(id);
        }
    },
    viewRelatedItem: function (e) {
        e.stopImmediatePropagation();
        let id = $(e.currentTarget).data('id');
        if (typeof this.options.viewItem === 'function') {
            this.options.viewRelatedItem(id);
        }
    }
});
PJQ.models.reports.Report = PJQ.models.BaseModel.extend({
    idAttribute: 'reportId',
    getExtraParameters: function (callback) {
        if (this.get('extraParameters') && !this.parameters) {
            this.parameters = new PJQ.collections.reports.ReportParameters();

            let extraParamsArray = this.get('extraParameters').split("|||");

            _.each(extraParamsArray, function (param, index) {
                let thisReportParam = param.split("||"),
                    parameterObject = new PJQ.models.reports.ReportParameter({
                        name: thisReportParam[0],
                        inputDisplayName: thisReportParam[1],
                        inputType: thisReportParam[2],
                        defaultValue: thisReportParam[4],
                        value: thisReportParam[4],
                        choices: []
                    }),
                    customField;

                let choices = [];
                if (parameterObject.get('inputType').toLowerCase() === 'select') {
                    let options = thisReportParam[3].split("|");

                    _.each(options, function (option) {
                        let splitOption = option.split(":")

                        // Check if custom field options exist
                        if (option.includes('ProjectCustomField:')) {
                            customField = new PJQ.models.projects.ProjectCustomField({
                                id: parseInt(splitOption[1])
                            })
                        } else if (option.includes('CompanyCustomField:')) {
                            customField = new PJQ.models.contacts.CompanyCustomField({
                                id: parseInt(splitOption[1])
                            })
                        } else if (option.includes('ContactCustomField:')) {
                            customField = new PJQ.models.contacts.ContactCustomField({
                                id: parseInt(splitOption[1])
                            })
                        } else if (option.includes('User:')) {
                            customField = new PJQ.collections.users.Users({})
                        } else {
                            choices.push(option);
                        }
                    }, this)

                    // Reused render function
                    let fnRender = _.bind(function () {
                        // Users uses a collection and not a model, so it needs to map through the models and not the choices
                        if (PJQ.helpers.objectHelpers.refinedType(customField, true) === 'backboneCollection') {
                            let customChoices = _.map(customField.models, function (model) {
                                return model.get('contactName');
                            }, this)

                            // If there are choices existing that aren't included in custom field choices, then push them
                            if (choices.length > 0) {
                                customChoices.unshift(...choices);
                            }

                            parameterObject.set('choices', customChoices);
                            // Custom fields use a model with a choices object
                        } else {
                            let customChoices = _.map(customField.choices.models, function (model) {
                                return model.get('choiceName');
                            }, this)

                            //If there are choices existing that aren't included in custom field choices, then push them
                            if (choices.length > 0) {
                                customChoices.unshift(...choices);
                            }

                            // Finish setting choices
                            parameterObject.set('choices', customChoices);
                        }
                        this.parameters.add(parameterObject);

                        // Needs to use callback due to render timing issues. Will use callback if it is the last extra parameter
                        if (index + 1 === extraParamsArray.length && typeof callback === 'function') {
                            callback(this.parameters);
                        }
                    }, this);

                    if (customField && !customField.isFetched) {
                        customField.fetch({
                            success: _.bind(function () {
                                fnRender();
                            }, this)
                        })
                    } else if (customField) {
                        fnRender();
                    }
                }
                // Parameter isn't a select input, so it is finished and can be pushed
                else {
                    this.parameters.add(parameterObject);

                    // Needs to use callback due to render timing issues. Will use callback if it is the last extra parameter
                    if (index + 1 === extraParamsArray.length && typeof callback === 'function') {
                        callback(this.parameters);
                    }
                }
            }, this)
        } else if (this.parameters) {
            if (typeof callback === 'function') {
                callback(this.parameters);
            }
        } else {
            callback(null);
        }
    },
});

PJQ.models.reports.ReportParameter = PJQ.models.BaseModel.extend({});

PJQ.collections.reports.ReportList = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.reports.Report,
    endpoint: function () {
        if (this.options.project) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'list'
                }
            ])
        } else {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'reports'
                },
                {
                    endpoint: 'list'
                }
            ]);
        }
    }
});

PJQ.collections.reports.ReportParameters = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.reports.ReportParameter
});
// temporary view for a custom report until we get a full new infrastructure in place
PJQ.views.reporting.SubcontractorDiversityStatusExportModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'Modal-Subcontractor-Diversity-Status-Export'),
		maxWidth: 600
	},
	events: {
		'click .export': 'export',
	},
	afterModalCreated: function () {
	},
	beforeRender: function () {
	},
	afterRender: function () {
		this.statePicker = new PJQ.inputs.StatePicker({
			el: this.$('select.input-select-state'),
			country: 'US',
			defaultValue: null,
			isMultiple: true,
			onChange: _.bind(function (value) {
				$('.export').prop('disabled', _.size(value) === 0);
			}, this)
		});
	},
	export: function () {
		let options = this.model.get('options');
		options[0].value.values = this.statePicker.getValue();

		if (typeof this.options.onDownload === 'function') {
			let loader = new PJQ.Loader(this.$('.modal-content'));
			this.options.onDownload(this.model.get('options'), _.bind(function () {
				loader.remove();
				this.removeModal();
			}, this));
		}
	}
});

PJQ.views.reporting.ReportView = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-view'),
		subTemplates: {
			reportError: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-error'),
			testReport: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'test-report'),
			extraParameters: new PJQ.templating.Template(PJQ.constants.modules.REPORTS, 'report-extra-parameters')
		}
	},
	events: {
		'click .export-report': 'exportReport',
		'click .btn-reload-report': 'reloadReport'
	},
	beforeFirstRender: function () {
		let fnRender = _.bind(function () {
			this.render();
		}, this);

		if (!this.collection) {
			this.collection = new PJQ.collections.reports.ReportList(null, {
				project: this.options.project
			});
		}
		if (!this.collection.isFetched) {
			this.collection.fetch({
				success: _.bind(function () {
					fnRender();
				}, this)
			})
		}
		else {
			fnRender();
		}
	},
	renderData: function () {
		return {
			reportList: this.collection,
			selectedReport: this.selectedReport
		};
	},
	afterRender: function () {
		new PJQ.inputs.Selectpicker({
			el: this.$('.report-list'),
			defaultValue: this.selectedReport ? this.selectedReport.get('reportId') : null,
			onChange: _.bind(function (value) {
				if (value === 'PANTERAMARKETING') {
					this.renderCustomReportMarketing();
				}
				else {
					this.selectedReport = this.collection.get(value);
					this.render();
				}
			}, this)
		});

		this.fromDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.input-date-from'),
			datepickerOptions: {
				defaultDate: this.selectedReport && this.selectedReport.get('fromDateDefault') ? this.calculateDate(this.selectedReport.get('fromDateDefault').replace('Math:', '').split('|')) : new Date(),
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function (value) {
				this.selectedReport.set('fromDate', PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE));
			}, this)
		});
		this.toDatePicker = new PJQ.inputs.Datepicker({
			el: this.$('.input-date-to'),
			datepickerOptions: {
				defaultDate: this.selectedReport && this.selectedReport.get('toDateDefault') ? this.calculateDate(this.selectedReport.get('toDateDefault').replace('Math:', '').split('|')) : new Date(),
				format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
			},
			onChange: _.bind(function (value) {
				this.selectedReport.set('toDate', PJQ.helpers.dateHelpers.getDateString(new Date(value), PJQ.helpers.dateHelpers.dateFormats.DATE));
			}, this)
		});

		// We have to get the Extra Parameters before we can generate the report
		if(this.selectedReport){
			this.renderExtraParameters();
		}
	},
	exportReport: function (e) {
		let $target = $(e.currentTarget),
			type = $target.data('type'),
			reportParams = {};

		if (this.selectedReport.get('hasDateFilter')) {
			reportParams["FromDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.fromDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
			reportParams["ToDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.toDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
		}

		if (this.selectedReport.parameters) {
			_.each(this.selectedReport.parameters.models, _.bind(function (param) {
				reportParams[param.get('name')] = param.get('value');
			}, this))
		}

		new PJQ.ajax.Request({
			endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'reports'
				},
				{
					endpoint: 'export'
				}
			]), data: {
				reportId: this.selectedReport.get('reportId'),
				projectId: PJQ.app.session.project ? PJQ.app.session.project.id : undefined,
				parameters: Object.keys(reportParams).length > 0 ? JSON.stringify(reportParams) : null,
				exportType: type ? type : 'pdf'
			}
		}).post().done(_.bind(function (response) {
			PJQ.files.downloadFile(response.url, {
				isEndpoint: false
			});
		}, this));
	},
	reloadReport: function () {
		this.generateReport(this.selectedReport.parameters);
	},
	renderCustomReportMarketing: function () {
		let $el = this.$('.report-container')
		$el.empty();

		this.$('.custom-hide').addClass('hidden');

		$el.html($('<img>', {
			style: 'width: 100%',
			src: '/portals/_default/customReports.png'
		}));
	},
	renderReport: function (data) {
		if (data) {
			let $el = this.$('.report-container')
			$el.empty();

			if (data.isImage) {
				$el.html($('<img>', {
					style: 'width: 100%',
					src: 'data:image/png;base64,' + data.reportData
				}));
			}
			else {
				let template = data.reportData;
				template = template.replace(`"<!DOCTYPE HTML PUBLIC \\"-//W3C//DTD HTML 4.01 Transitional//EN\\">`, '');
				template = template.replace(/\\/g, '');
				this.$('.report-container').html(template);
			}
		}
	},
	generateReport: function (params) {
		if (this.selectedReport) {
			let loader = new PJQ.Loader(this.$('.report-container'));
			let reportParams = {};

			if (this.selectedReport.get('hasDateFilter')) {
				reportParams["FromDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.fromDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
				reportParams["ToDate"] = PJQ.helpers.dateHelpers.getDateString(new Date(this.toDatePicker.value), PJQ.helpers.dateHelpers.dateFormats.DATE);
			}

			if (params) {
				_.each(params.models, _.bind(function (param) {
					reportParams[param.get('name')] = param.get('value');
				}, this))
			}

			new PJQ.ajax.Request({
				endpoint: "/report/GenerateReport",
				data: {
					reportId: this.selectedReport.get('reportId'),
					projectId: PJQ.app.session.project ? PJQ.app.session.project.id : undefined,
					parameters: Object.keys(reportParams).length > 0 ? JSON.stringify(reportParams) : null
				}
			}).post().done(_.bind(function (data) {
				loader.remove();
				this.renderReport(data);
			}, this)).fail(_.bind(function () {
				loader.remove();
				this.renderError();
			}, this));
		}
	},
	renderError: function () {
		this.renderSubTemplate(false, this.options.subTemplates.reportError, this.$('.report-container'));
	},
	calculateDate: function (mathArr) {
		let dnow = new Date(),
			thisMonth = dnow.getMonth() + 1,
			thisDay = dnow.getDate(),
			thisYear = dnow.getFullYear(),
			thisMonthMath = mathArr[0],
			thisDayMath = mathArr[1],
			thisYearMath = mathArr[2],
			thisMonthIsStatic = thisMonthMath.toLowerCase().indexOf('s:') != -1 ? true : false,
			thisDayIsStatic = thisDayMath.toLowerCase().indexOf('s:') != -1 ? true : false,
			thisYearIsStatic = thisYearMath.toLowerCase().indexOf('s:') != -1 ? true : false;
		if (thisMonthIsStatic) {
			thisMonth = thisMonthMath.replace('s:', '');
		}
		else {
			thisMonth = thisMonth + parseInt(thisMonthMath);
		}
		if (thisDayIsStatic) {
			thisDay = thisDayMath.replace('s:', '');
		}
		else {
			thisDay = thisDay + parseInt(thisDayMath);
		}
		if (thisYearIsStatic) {
			thisYear = thisYearMath.replace('s:', '');
		}
		else {
			thisYear = thisYear + parseInt(thisYearMath);
		}

		let daysInMonth;
		if (thisDay < 1 && !thisDayIsStatic) {
			if (thisMonthIsStatic) {
				thisDay = 1;
				daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear);
			}
			else {
				thisMonth = thisMonth - 1;
				daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear);
				thisDay = daysInMonth + thisDay;
			}
		}
		else {
			daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear);
		}
		if (thisDay > daysInMonth) {
			if (thisMonthIsStatic) {
				thisMonth = thisMonth + 1;
				daysInMonth = PJQ.helpers.dateHelpers.GetDaysInMonth(thisMonth, thisYear)
				thisDay = thisDay - daysInMonth;
			}
			else {
				thisDay = daysInMonth;
			}
		}
		if (thisMonth < 1 && !thisMonthIsStatic) {
			thisMonth = thisMonth + 12;
			if (!thisYearIsStatic) {
				thisYear = thisYear - 1;
			}
		}
		else if (thisMonth > 12 && !thisMonthIsStatic) {
			thisMonth = thisMonth - 12;
			if (!thisYearIsStatic) {
				thisYear = thisYear + 1;
			}
		}

		return new Date(thisYear, thisMonth, thisDay);
	},
	renderExtraParameters: function () {
		if (this.selectedReport && this.selectedReport.get('extraParameters') && this.selectedReport.get('extraParameters') !== 'NULL') {
			this.selectedReport.getExtraParameters(_.bind(function (params) {
				// Render subtemplate with returned parameters
				this.renderSubTemplate(false, this.options.subTemplates.extraParameters, this.$('.extra-parameter-inputs'), {
					extraParams: params.models
				});

				// Add any binders or inputs required for parameters
				_.each(params.models, function (param) {
					if (param.get('inputType').toLowerCase() === 'select') {
						new PJQ.inputs.Selectpicker({
							el: this.$(('select.' + param.cid)),
							defaultValue: param.get('defaultValue'),
							onChange: _.bind(function (value) {
								param.set('value', value);
							}, this)
						});
					}
					else if (param.get('inputType').toLowerCase() === 'date') {
						new PJQ.inputs.Datepicker({
							el: this.$(('.' + param.cid)),
							datepickerOptions: {
								// defaultDate: option.defaultValue ? option.defaultValue.to : null,
								format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE
							},
							onChange: _.bind(function (value) {
								param.set('value', value);
							}, this)
						});
					}
					else {
						new PJQ.Binder(this.$el, param, {
							watchElements: [
								('.' + param.cid)
							]
						});
					}
				}, this)
				//Generate the report once the parameters are established
				this.generateReport(params);
			}, this));
		}
		else {
			// There are no parameters to worry about, so we can just generate the report
			this.generateReport();
		}
	}
});